<template>
  <div>
    <div class="login-container" v-pageBuried data-page-buried="BG_HYKLQ_NWKF">
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f63ebba523a7cf473a124950656a857e.png"
        alt=""
      />
      <img
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ac7fef8be2ed1e919276f9dc2f7135a6.png"
        alt=""
        class="btn"
        @click="bindRegister"
        v-clickBuried
        data-click-buried="CLICK_HYKLQ_NWKF"
      />
    </div>
    <van-popup v-model="showLogin" position="bottom">
      <MyLogin
        title="填写您的信息"
        @close="bindLoginClose"
        @login="bindLogin"
      ></MyLogin>
    </van-popup>
  </div>
</template>
<script>
import MyLogin from '@/views/activity/camp-introduce/components/login.vue'
export default {
  components: {
    MyLogin
  },
  data() {
    return {
      showLogin: false
    }
  },
  mounted() {
    /* this.screenHeight = window.innerHeight + 'px';
        window.addEventListener("visibilitychange",()=>{
         if(document.visibilityState === 'visible'){
           window.innerHeight = 900;
         }
        }); */
  },
  methods: {
    bindRegister() {
      this.showLogin = true
    },
    bindLoginClose() {
      this.showLogin = false
    },
    bindLogin(options) {
      let params = {
        phone: options.phone,
        identify_code: options.code,
        areaCode: '86',
        gender: '0',
        r_from: '7'
      }
      this.$http
        .postBaseApp('member/WaterClock/registerWaterUser', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$dialog
              .alert({
                title: '',
                message: res.data.msg || '注册成功'
              })
              .then(() => {
                location.href = 'https://member3.gymcity.com.cn/#/app-download'
              })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch()
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  width: 100%;
  position: relative;
  @include paddingBottom(0px);
  .image {
    width: 100%;
  }
  .btn {
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 357px;
    @include fixedBottom(0px);
  }
}

.login-content {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>
